import React from "react";
import Loader from "../loader";
import { t } from "../../../helpers/translator";
import GamesWrapperStandart from "../gamesWrapperStandart";
import Expandable from "../../containers/expandable";

export default function gameListTemplate () {
    let { loaded, compNames, sportAlias, selectorKey, gameType } = this.props;

    if (loaded && compNames && sportAlias !== "boosted") {
        return (<div id='getScrollPosition' className={"all-games-list-wrapper" + (loaded ? " loading" : "")} ref={(el) => this.scrollGamesListStandart = el} onScroll={this.handleScrollListener} >
            {
                (() => {

                    const outPutData = [];
                    for (let i = 0, gameCount = 0; i < compNames.length; i++) {

                        gameCount += compNames[i][compNames[i].key].length;
                        if (gameCount > this.state.gameLoadCount) {
                            outPutData.push(([<Expandable openAnywhere={true} uiKey={compNames[i].key} className={"sport-region-info-m competition-info " + sportAlias} key={[i]}>
                                <div className={"league-name-view-m " + sportAlias}>
                                    <h3>{compNames[i].key || t("No games found")}</h3>
                                </div>
                                <div className="arrow-view-m" />
                            </Expandable>,
                            <div className="competition-naw-wrapper-m" key={[i]}>
                                <div className="competition-list-view-m">
                                    <div className="date-list-games-m">
                                        <GamesWrapperStandart key={compNames[i].regionAlias + compNames[i].key}
                                            compName={compNames[i].data}
                                            selectorKey={selectorKey}
                                            gameType={gameType}
                                            sportAlias={sportAlias} />
                                    </div>
                                </div>
                            </div>]));
                            break;
                        }
                        outPutData.push(([<Expandable openAnywhere={true} uiKey={compNames[i].key} className={"sport-region-info-m competition-info " + sportAlias} key={[i]}>
                            <div className={"league-name-view-m " + sportAlias}>
                                <h3>{compNames[i].key || t("No games found")}</h3>
                            </div>
                            <div className="arrow-view-m" />
                        </Expandable>,
                        <div className="competition-naw-wrapper-m" key={[i]}>
                            <div className="competition-list-view-m">
                                <div className="date-list-games-m">
                                    <GamesWrapperStandart key={compNames[i].regionAlias + compNames[i].key}
                                        compName={compNames[i].data}
                                        selectorKey={selectorKey}
                                        gameType={gameType}
                                        sportAlias={sportAlias} />
                                </div>
                            </div>
                        </div>
                        ]));
                    }
                    return outPutData;
                })()
            }
            <div className="scroll-b-view-w">
                <div className="single-s-b top-v" onClick={this.scroll(-200)} />
                <div className="single-s-b bot-v" onClick={this.scroll(200)} />
            </div>
        </div>);
    } else if (loaded && compNames && sportAlias === "boosted") {
        return (<div id='getScrollPosition' className={"all-games-list-wrapper boosted" + (loaded ? " loading" : "")} ref={(el) => this.scrollGamesListStandart = el} onScroll={this.handleScrollListener} >
            {
                compNames.map((sportType) => {
                    return (
                        <div className={`sport-list-header ${sportAlias}`} key={sportType.temp}>
                            <div className='sport-list-sport-name'><p>{sportType.temp}</p></div>
                            {
                                (() => {
                                    const outPutData = [];
                                    for (let i = 0; i < sportType.data.length; i++) {
                                        outPutData.push(([<Expandable openAnywhere={true} uiKey={sportType.data[i].key} className={"sport-region-info-m competition-info " + sportAlias} key={[i]}>
                                            <div className={"league-name-view-m " + sportAlias}>
                                                <h3>{sportType.data[i].key || t("No games found")}</h3>
                                            </div>
                                            <div className="arrow-view-m" />
                                        </Expandable>,
                                        <div className="competition-naw-wrapper-m" key={sportType.data[i].key}>
                                            <div className="competition-list-view-m">
                                                <div className="date-list-games-m">
                                                    <GamesWrapperStandart key={sportType.data[i].regionAlias + sportType.data[i].key}
                                                        compName={sportType.data[i]}
                                                        regionAlias={sportType.data[i].key}
                                                        selectorKey={selectorKey}
                                                        gameType={gameType}
                                                        sportAlias={sportAlias} />
                                                </div>
                                            </div>
                                        </div>
                                        ]));
                                    }
                                    return outPutData;
                                })()
                            }
                        </div>
                    );
                })
            }
            <div className="scroll-b-view-w">
                <div className="single-s-b top-v" onClick={this.scroll(-200)} />
                <div className="single-s-b bot-v" onClick={this.scroll(200)} />
            </div>
        </div>);
    } else {
        return <Loader />;
    }
}